import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SqlService } from '../../Database/sql.service';

import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-prepare-batches',
  templateUrl: './prepare-batches.component.html',
  styleUrls: ['./prepare-batches.component.css'],
})
export class PrepareBatchesComponent implements OnInit {
  BoxNumber = '';

  closeResult = '';
  DisplayErrormessage = '';
  PopupTitle = '';

  firstscreen = true;
  Secondscreen = false;

  AllSerialBatchnumbers = [{}];
  AllSerialnumbers = [""];

  AllocatedSerialnumbers = [''];

  Boxsize = 0;
  Batchsize = 0;
  status = '';
  CurrentBatch = 0;

  InputSerialNumber = [''];

  ConfirmReset = '';

  PossibleBoxNumbers = [''];
  PossibleBoxNumbersMain = [''];
  PossibleBox = '';

  forceClose = false;

  constructor(
    private dbService: SqlService,
    private router: Router,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.GetAllBoxNames(" Status = 'Recieved' OR Status = 'In Prep' ");
  }

  PossibleBoxChanged() {
    this.BoxNumber = this.PossibleBox[0];
  }

  BoxNameChanged() {
    this.GetAllBoxNames(
      " (Status = 'Recieved' OR Status = 'In Prep') AND ([Pactel].[dbo].[Boxes].Boxno like '" +
      this.BoxNumber +
      "%') "
    );
  }

  GetAllBoxNames(condition: string) {
    Swal.fire({
      title: 'Loading Boxes',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    this.PossibleBoxNumbers.splice(0);
    this.PossibleBoxNumbersMain.splice(0);

    let formData = new FormData(); // Currently empty
    formData.set('Where', condition);

    this.dbService.getTopBoxesNames(formData).subscribe((ret: any) => {
      if (ret != 'false') {
        let a = (ret as string).split(';');

        this.PossibleBoxNumbersMain = a;

        (ret as string).split(';').forEach((element) => {
          this.PossibleBoxNumbers.push(element);
        });

        Swal.close();
      } else {
        this.PopupTitle = 'Error';
        this.DisplayErrormessage =
          'Please check your internet connection and try again';
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    });
  }

  async Next() {
    if (!this.PossibleBoxNumbersMain.includes(this.BoxNumber)) {
      this.DisplayErrormessage =
        'The status of this box is incorrect. Please select a Box number from the list.';
      this.PopupTitle = 'Error';

      let element: HTMLButtonElement = document.getElementById(
        'ErrorButton'
      ) as HTMLButtonElement;
      element.click();
    } else {
      this.CurrentBatch = 0;
      Swal.fire({
        title: 'Loading Box details',
        showConfirmButton: false,
        toast: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      await this.dbService
        .GetBoxDetails(this.BoxNumber)
        .subscribe((ret: any) => {
          if (ret != 'false' && ret != '') {
            this.InputSerialNumber.splice(0);
            this.AllSerialBatchnumbers.splice(0);
            this.AllSerialnumbers.splice(0);
            this.AllocatedSerialnumbers.splice(0);

            let a = (ret as string).split(';');
            a.splice(a.length - 1, 1);

            let firsttemp = a[0].split(',');
            //this.Boxsize = Number.parseInt(firsttemp[0]); -> BoxSizeDirect
            //this.Batchsize = Number.parseInt(firsttemp[1]); -> BatchSizeDirect
            this.Boxsize = Number.parseInt(firsttemp[2]); // BoxSizeInDirect
            this.Batchsize = Number.parseInt(firsttemp[3]); // BatchSizeInDirect
            this.status = firsttemp[4];
            //Branch

            if (this.status == 'Prepped' || this.status == 'Allocated') {
              this.PopupTitle = 'Success';
              this.DisplayErrormessage = 'This Box has been prepped already';
              let element: HTMLButtonElement = document.getElementById(
                'ErrorButton'
              ) as HTMLButtonElement;
              element.click();
              this.Reset();
            } else {
              a.splice(0, 1);

              a.forEach((element) => {
                let secondtemp = element.split(',');
                let temp = {
                  SerialNumber: secondtemp[0],
                  BatchNo: secondtemp[1],
                };

                if (secondtemp[4] == this.BoxNumber) {
                  if (Number.parseInt(secondtemp[1]) > this.CurrentBatch) {
                    this.CurrentBatch = Number.parseInt(secondtemp[1]);
                  }

                  if (Number.parseInt(secondtemp[1]) > 0) {
                    this.AllocatedSerialnumbers.push(secondtemp[0]);
                  }

                  this.AllSerialnumbers.push(secondtemp[0]);
                  this.AllSerialBatchnumbers.push(temp);
                }
              });

              this.firstscreen = false;
              this.Secondscreen = true;
              this.CurrentBatch += 1;
            }
          } else {
            this.PopupTitle = 'Error';
            this.DisplayErrormessage =
              'This box is not loaded onto the system, please check the box number and try again.';
            let element: HTMLButtonElement = document.getElementById(
              'ErrorButton'
            ) as HTMLButtonElement;
            element.click();
          }
          Swal.close();
        });
    }
  }

  Reset() {
    this.BoxNumber = '';

    this.InputSerialNumber.splice(0);
    this.AllSerialBatchnumbers.splice(0);
    this.AllSerialnumbers.splice(0);
    this.AllocatedSerialnumbers.splice(0);

    this.firstscreen = true;
    this.Secondscreen = false;
    this.GetAllBoxNames(" Status = 'Recieved' OR Status = 'In Prep' ");
  }

  ResetBatch() {
    this.InputSerialNumber.splice(0);
  }

  async NextBatch() {

    if (this.InputSerialNumber.length < this.Batchsize) {
      this.PopupTitle = 'Error';
      this.DisplayErrormessage = 'Please fill in all serial numbers';
      let element: HTMLButtonElement = document.getElementById(
        'ErrorButtonConstant'
      ) as HTMLButtonElement;
      element.click();
      bSerialsValid = false;
      return;
    }

    Swal.fire({
      title: 'Saving batch details',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    var bSerialsValid = true;
    var errorMessage = '';
    var NewSerialnumbers = [''];
    NewSerialnumbers.splice(0);

    this.InputSerialNumber.forEach((InputSerialNumberEl) => {
      if (InputSerialNumberEl == undefined || InputSerialNumberEl == null) {
        this.PopupTitle = 'Error';
        this.DisplayErrormessage = 'Please fill in all serial numbers';
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButtonConstant'
        ) as HTMLButtonElement;
        element.click();
        bSerialsValid = false;
        return;
      }

      if (this.AllSerialnumbers.includes(InputSerialNumberEl)) {

        if (this.AllocatedSerialnumbers.includes(InputSerialNumberEl)) {
          bSerialsValid = false;
          errorMessage =
            'One of these serial numbers have been allocated a batch already(' +
            InputSerialNumberEl +
            ')';
        } else {
          if (NewSerialnumbers.includes(InputSerialNumberEl)) {
            bSerialsValid = false;
            errorMessage =
              'There are duplicated serial numbers in this batch(' +
              InputSerialNumberEl +
              ')';
          } else {
            NewSerialnumbers.push(InputSerialNumberEl);
          }
        }

      } else {
        bSerialsValid = false;
        errorMessage = "This serial number does not exsist in the box(" + InputSerialNumberEl + ")";
      }
    });

    if (bSerialsValid != true) {
      Swal.close();
      this.PopupTitle = 'Error';
      this.DisplayErrormessage = errorMessage;
      let element: HTMLButtonElement = document.getElementById(
        'ErrorButtonConstant'
      ) as HTMLButtonElement;
      element.click();
    } else {
      await this.SaveBatch();
    }
  }

  async SaveBatch() {
    Swal.fire({
      title: 'Saving batch details',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    var formData = new FormData(); // Currently empty

    var sql = '';

    let sTemp = '';
    this.InputSerialNumber.forEach((element) => {
      sTemp += "'" + element + "',";
    });
    sTemp = sTemp.substring(0, sTemp.length - 1); //remove extra ,
    sql =
      "UPDATE [Pactel].[dbo].[BoxDetails] SET Batchno='" +
      this.CurrentBatch +
      "' WHERE Boxno='" + this.BoxNumber + "' AND Serialno in(" +
      sTemp +
      ");";

    if (this.InputSerialNumber.length == 0) {
      if (this.forceClose == true) {
        this.FinanilizeAllBatches();
      }
    } else {
      sql +=
        "UPDATE [Pactel].[dbo].[Boxes] SET Status='In Prep' WHERE Boxno='" +
        this.BoxNumber +
        "';";
      formData.set('SQL', sql);

      this.dbService.AddNewBatch(formData).subscribe((ret: any) => {
        if (ret != 'false') {
          if (this.CurrentBatch >= this.Boxsize / this.Batchsize) {
            this.FinanilizeAllBatches();
          } else {
            if (this.forceClose == true) {
              this.FinanilizeAllBatches();
            } else {
              this.ResetBatch();
              this.Next();

              this.PopupTitle = 'Success';
              this.DisplayErrormessage =
                'End of Batch number:' + this.CurrentBatch;
              let element: HTMLButtonElement = document.getElementById(
                'ErrorButtonConstant'
              ) as HTMLButtonElement;
              element.click();
            }
          }
        } else {
          this.PopupTitle = 'Error';
          this.DisplayErrormessage =
            'Please check your internet connection and try again';
          let element: HTMLButtonElement = document.getElementById(
            'ErrorButton'
          ) as HTMLButtonElement;
          element.click();
        }

        Swal.close();
      });
    }
  }

  async FinanilizeAllBatches() {
    var formData = new FormData(); // Currently empty
    formData.set('BoxNumber', this.BoxNumber);

    //Display another screen, to say all batches are done. Change status to 'Prepped', and go to the Allocate Distributor
    this.dbService.FinanilizeAllBatches(formData).subscribe((ret: any) => {
      if (ret != 'false') {
        this.PopupTitle = 'Success';
        this.DisplayErrormessage =
          'All Serial numbers are assigned to a batch.' +
          '<br/><br/>' +
          'Box Number: ' +
          this.BoxNumber +
          ' has been Prepped successfully.';
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();

        this.Reset();
      } else {
        this.PopupTitle = 'Error';
        this.DisplayErrormessage =
          'Please check your internet connection and try again';
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();
      }
      Swal.close();
    });
  }

  ResetBox() {
    this.ConfirmReset = '';
    this.PopupTitle = 'Warning!';
    this.DisplayErrormessage =
      "Please type in 'RESET' below to RESET the whole the box.";
    let element: HTMLButtonElement = document.getElementById(
      'btnConfirmReset'
    ) as HTMLButtonElement;
    element.click();
  }

  async ActuallyResetBox() {
    var formData = new FormData(); // Currently empty
    formData.set('BoxNumber', this.BoxNumber);

    await this.dbService.ClearBoxBatches(formData).subscribe((ret: any) => {
      if (ret != 'false') {
        this.PopupTitle = 'Success';

        this.DisplayErrormessage =
          'All batches have been reset.' +
          '<br/><br/>' +
          'Box Number: ' +
          this.BoxNumber +
          ' has been reset successfully.';

        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();

        this.ResetBatch();
        this.Reset();
      } else {
        this.PopupTitle = 'Error';
        this.DisplayErrormessage =
          'Please check your internet connection and try again';
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();
      }
    });
  }

  openConfirmReset(content: any) {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = 'Closed with: ${result}';
          if (this.ConfirmReset == 'RESET') {
            this.ActuallyResetBox();
          }
        },
        (reason) => {
          this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
        }
      );
  }

  ForceClose() {
    this.ConfirmReset = '';
    this.PopupTitle = 'Warning!';
    this.DisplayErrormessage =
      "Please type in 'DONE' below to FORCE close the box.";
    let element: HTMLButtonElement = document.getElementById(
      'btnConfirmClose'
    ) as HTMLButtonElement;
    element.click();
  }

  openConfirmForceClose(content: any) {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = 'Closed with: ${result}';

          if (this.ConfirmReset == 'DONE') {
            this.forceClose = true;
            this.SaveBatch();
          }
        },
        (reason) => {
          this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
        }
      );
  }

  open(content: any) {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = 'Closed with: ${result}';
        },
        (reason) => {
          this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
          //let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          //element.click();
        }
      );
  }

  open2(content: any) {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = 'Closed with: ${result}';
        },
        (reason) => {
          this.closeResult = ' Dismissed ${this.getDismissReason(reason)}';
          let element: HTMLButtonElement = document.getElementById(
            'ErrorButtonConstant'
          ) as HTMLButtonElement;
          element.click();
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return 'with: ${reason}';
    }
  }
}
